import axios, { AxiosError, AxiosResponse, InternalAxiosRequestConfig } from 'axios';
import Cookies from 'js-cookie';
import toast from 'react-hot-toast';
import resources from 'resources.json';

const getCookie = () => {
  return Cookies.get('XSRF-TOKEN');
}

const AXIOS = axios.create();

/**
 * Flag to track if a CSRF retry is already in progress,
 * preventing infinite retry loops.
 */
const CSRF_RETRY_HEADER = '_csrfRetry';

const onRequest = (config: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
  config.headers = config.headers ?? {};
  config.headers['X-XSRF-TOKEN'] = getCookie();
  return config;
}

const onRequestError = (error: AxiosError): Promise<AxiosError> => {
  return Promise.reject(error);
}


const onResponse = (response: AxiosResponse): AxiosResponse => {
  return response;
}

const clearStaleXsrfToken = () => {
  Cookies.remove('XSRF-TOKEN');
  Cookies.remove('XSRF-TOKEN', { path: '/' });
}

const onResponseError = (error: AxiosError): Promise<AxiosError> => {
  if (error.response) {
    const status = error.response.status;

    if (status === 403) {
      toast.error(resources.errorMessage.PERMISSION_ERROR, {
        id: "403",
      });

      return Promise.reject(error);
    }

    if (status === 401) {
      toast.error("Session expired. Redirecting to login...", {
        id: '401'
      });

      // Clear stale XSRF token to prevent redirect loop on the login page
      clearStaleXsrfToken();

      // Clear auth-related data
      localStorage.removeItem("user");
      sessionStorage.clear();
      const userLoginUrl = localStorage.getItem('userLoginUrl');

      // Redirect to login page
      setTimeout(() => {
        if (!userLoginUrl?.includes('sessionExpired')) {
          if (userLoginUrl?.includes('?token=')) {
            window.location.href = `${userLoginUrl}&sessionExpired=true`;
          }
          else {
            window.location.href = `${userLoginUrl}?sessionExpired=true`;
          }
        }
      }, 500);

      // Return a never-resolving promise to prevent this error from propagating
      // to React Query / component error handlers, which would flash the
      // "Something Went Wrong" page before the redirect completes.
      return new Promise(() => { }) as any;
    }
  }

  return Promise.reject(error);
};


AXIOS.interceptors.request.use(onRequest, onRequestError);

AXIOS.interceptors.response.use(onResponse, onResponseError);

export { AXIOS };